import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from '../../_services/common.service';
import { FlashMessagesService } from "angular2-flash-messages";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
export interface DialogData {
  name: string;
  message: string;
  manageData: any;
}

@Component({
  selector: 'app-client-address-edit',
  templateUrl: './client-address-edit.component.html',
  styleUrls: ['./client-address-edit.component.css']
})
export class ClientAddressEditComponent implements OnInit {
  @Output() toggleForm = new EventEmitter<boolean>();
  public clientOptions: any = {};
  public clientLists: Array<any> = [];
  public result = "";
  public userId: any;
  public addressId: any;
  public showForm = false;
  constructor
    (
      public dialogRef: MatDialogRef<ClientAddressEditComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData,
      public dialog: MatDialog,
      private commonService: CommonService,
      private _flashMessagesService: FlashMessagesService,
    ) {

  }

  ngOnInit() {
    this.getUserAddressData();
  }

  onNoClick(): void {
    this.dialogRef.close("success");
  }

  getUserAddressData = function () {
    this.clientOptions = {
      id: this.data.manageData.client_id
    };

    this.commonService.apiService(
      "POST",
      "user/addresses",
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.clientLists = response.data;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  isEnabled(check_val) {
    return check_val == "1" ? true : false;
  }

  updateClientAddress = function (id) {
    this.clientOptions = {
      id: id,
      type: this.data.manageData.type
    };
    this.commonService.apiService(
      "POST",
      "user/address/default",
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show(this.data.manageData.type + " Address updated successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });
          this.result = "success";
          var obj = this;
          setTimeout(() => {
            obj.onNoClick();
          }, 2000);
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

  viewclientAddress() {
    this.dialogRef.close("showAddress");
  }

  editClientAddress(addressId) {
    // const dialogResult = {
    //   addressId: addressId,
    //   userId: this.data.manageData.client_id,
    //   statusType: 'editAddress'
    // };
    // this.dialogRef.close(dialogResult);
    this.addressId = addressId;
    this.userId = this.data.manageData.client_id;
    this.showForm = !this.showForm;
  }

  openDeleteDialog(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this address",
        manageData: { id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.id) {
        this.deleteAttribute(result.id);
      }
    });
  }

  deleteAttribute = function (id) {
    this.commonService.apiService(
      "DELETE",
      "user/address/" + id
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.getUserAddressData();
          this.dialogRef.close("success");
          this._flashMessagesService.show("Address deleted successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  }

  showClientAddressForm(response) {
    this.showForm = !this.showForm;
    this.getUserAddressData();
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/client-address-edit/client-address-edit.component.ts